function t(n, f) {
  return n === f || n !== n && f !== f;
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/eq.js
// module id = 252
// module chunks = 67